import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import colors from 'vuetify/lib/util/colors'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'font-awesome/css/font-awesome.css'
import VueMq from 'vue-mq'
import VuetifyConfirmPlugin from 'vuetify-confirm'
import VueBlobJsonCsv from 'vue-blob-json-csv'
import { VueMaskDirective } from 'v-mask'
import VueGoogleCharts from 'vue-google-charts'
import QrcodeVue from 'qrcode.vue'

Vue.use(VueGoogleCharts)
Vue.directive('mask', VueMaskDirective)
Vue.use(VueBlobJsonCsv)
Vue.use(QrcodeVue)
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sm: 450,
    md: 1250,
    lg: Infinity
  },
  defaultBreakpoint: 'sm' // customize this for SSR
})

const vuetify = new Vuetify({
  icons: {
    iconfont: 'md' || 'fa'
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: colors.green.darken2, // '#43A047', // '#09ac0f', // colors.blue.darken3,
        secondary: colors.grey.darken1,
        accent: '#f28e02', // colors.shades.black,
        error: colors.red.accent3
      }
    }
  }
})
Vue.use(VuetifyConfirmPlugin, {
  vuetify,
  buttonTrueText: 'Yes',
  buttonFalseText: 'No',
  color: 'warning',
  icon: 'warning',
  title: 'Warning',
  width: 350,
  persistent: false,
  property: '$confirm'
})
Vue.use(Vuetify)
export default vuetify
